export class MyItems {

    leadID: number;
    queryRemarks: string;
    typeOfProperty: number;
    status: number;
    rangeFrom: number;
    rangeTo: number;
    compactLabel: string;
    recivedOn: Date;
    projectName: string;
    assignedTo: string;
    builderInterest: string;
    statusId: number;
    token: string;
    statusDate: Date;
    companyId: number;
    leadItemID: number;
    userName: string;
    isAssigned: Boolean;
    
    }